// extracted by mini-css-extract-plugin
export default {"root":"Move2SafeTooltip__root--2og8O","tipContent":"Move2SafeTooltip__tipContent--1NcXD","tipText":"Move2SafeTooltip__tipText--2DPS6"};